import React, { FunctionComponent } from 'react';
import IActionButtonProps from '../IActionButtonProps';
import ReserveOnlineButtonContainer from './ReserveOnlineButtonContainer';
import SubmitCarToUrlButtonContainer from './SubmitCarToUrlButtonContainer';

const SubmitContainer: FunctionComponent<IActionButtonProps> = ({ config }) => {
  if (config.isCheckoutLiteEnabled && config.reserveOnlineUrl) {
    return <ReserveOnlineButtonContainer config={config} />;
  } else if (config.carSubmissionURL) {
    return <SubmitCarToUrlButtonContainer config={config} />;
  }

  return null;
};

export default SubmitContainer;
